import Player from './audio-player';

export default Player;
